import Onboarding from './onboardingSlice';
import Auth from './authSlice';
import App from './appSlice';
import TicketListReducer from './Ticketing/ticket-list-reducer';
import TicketDetailsReducer from './Ticketing/ticket-details-reducer';
import CommentsReducer from './Ticketing/comments-reducer';
import TicketingModalReducer from './Ticketing/ticketing-modal-reducer';

export default {
  onboarding: Onboarding,
  app: App,
  auth: Auth,
  ticketListReducer: TicketListReducer,
  ticketDetailsReducer: TicketDetailsReducer,
  commentsReducer: CommentsReducer,
  ticketingModalReducer: TicketingModalReducer,
};
